import React from "react";
import "react-calendar/dist/Calendar.css";
import { formatTime } from "../../shared/helper/helper.service";

const SlotView = (props) => {
  const { filteredSlot, selectedSlot, onClick, selectedDoctor } = props;

  return (
    <div>
      {filteredSlot[0]?.timeSlots?.length > 0 ? (
        <div className="slot-view">
          <h3>You have selected {selectedDoctor?.doctorname}. Choose preferred slot from below options:</h3>
          <div>
            {filteredSlot[0]?.timeSlots.map((slot, i) => {
              return (
                <button
                  style={{ position: 'relative' }}
                  disabled={!slot?.isFree}
                  className={
                    slot?.isFree
                      ? selectedSlot?.time == slot?.time
                        ? "time-slot active-slot"
                        : "time-slot"
                      : "time-slot slot-dissabled"
                  }
                  onClick={() => { onClick(slot) }}
                >
                  {slot?.time && formatTime(slot?.time)}
                  {selectedSlot?.time == slot?.time && <img style={{ width: 22, height: 'auto', objectFit: 'contain', marginLeft: 5, marginTop: -5 }} src={require('../../asstes/images/checkmark.png')} />}
                </button>
              );
            })}
          </div>
          {/* <p className="note-style">
            Each consult will be for 45 minutes, which would cover a detailed
            discussion and a USG scan
          </p> */}
        </div>
      ) : (
        <div>
          <p className="note-style">
            You have selected {selectedDoctor?.doctorname}, there are no slots available for the date you have selected. Please select another date.
          </p>
        </div>
      )}
    </div>
  );
};

export default SlotView;
